import React from "react";
import PropTypes from "prop-types";
import ArticleSearchContainer from "../../../ArticleSearchForm/containers/ArticleSearchContainer";
import Article from "../../../entities/article";
import ArticleBoxThumbnail from "../../ArticleBoxThumbnail";

function RecommendArticleBox({ article }) {
  const { requestFromSp } = ArticleSearchContainer.useContainer();
  const articleEntity = new Article({ ...article });

  const imageWidth = requestFromSp ? 200 : 210;
  const imageHeight = requestFromSp ? 157.5 : 120;
  const imageUrl = requestFromSp
    ? articleEntity.large_pic_url
    : articleEntity.small_pic_url;
  const userIconUrl = articleEntity.user?.icon_url;

  return (
    <li
      className="l_childBox isWideInside recArticleBox"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(articleEntity.gtm_ecommerce_data_attributes?.() ?? {})}
    >
      <a href={articleEntity.path()}>
        <ArticleBoxThumbnail
          imageUrl={imageUrl}
          userIconUrl={userIconUrl}
          width={imageWidth}
          height={imageHeight}
          showUserIconBackground
        />
        <div className="recommendSentence">
          <div className="recWrap">
            <span className="p_icon isGetActivityLocations">{`${
              articleEntity.display_activity_locations_small
            } ${articleEntity.user_name()}`}</span>
            <p className="recTitle">{articleEntity.title}</p>
            <span className="p_icon isGetWorkingForms">
              {articleEntity.is_job
                ? articleEntity.working_form_slim_names
                : articleEntity.kinds.name}
            </span>
          </div>
        </div>
      </a>
    </li>
  );
}

RecommendArticleBox.propTypes = {
  article: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    large_pic_url: PropTypes.string,
    small_pic_url: PropTypes.string,
    display_activity_locations_small: PropTypes.string,
    is_job: PropTypes.bool,
    working_form_slim_names: PropTypes.string,
    user: PropTypes.shape({
      icon_url: PropTypes.string,
    }),
    kinds: PropTypes.shape({
      name: PropTypes.string,
    }),
    gtm_ecommerce_data: PropTypes.objectOf(PropTypes.any),
  }).isRequired,
};

export default RecommendArticleBox;
